import * as Sentry from '@sentry/react';
import { StateCreator } from 'zustand';

import { sentryOptions } from './constants/sentryOptions';
import { ErrorReportingState } from './types/ErrorReportingState';

export const errorReportingStore: StateCreator<ErrorReportingState> = () => ({
  captureException: (error, captureContext): void => {
    Sentry.captureException(error, captureContext);
  },

  init: (): void => {
    Sentry.init(sentryOptions);
  },

  wrapCreateBrowserRouter: (createRouter): typeof createRouter => {
    return Sentry.wrapCreateBrowserRouter(createRouter);
  },
});
